<template>
  <div v-if="getPermission.stc.view">  

    <settlement-form ref="SettlementForm" mode="CREATE" :onUpdate="updatePayrollNum"/>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div class = "md-layout-item md-size-35">
            <auto-complete-master-data-select
              group="STC_DRIVER_COMPANY"
              label="Driver Company"
              :on-item-changed="handleDriverCompanyChanged">
            </auto-complete-master-data-select>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.settleDate.startDate">
                <label>Settle From</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.settleDate.endDate">
                <label>Settle To</label>
              </datepicker>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <md-field>
                <label size="lg" class = "textlabel" for="docType" >Status</label>
                  <md-select v-model="searchRequest.billingStatus">
                  <md-option value="BLC">BLC Cost Confirm</md-option>
                  <md-option value="LOK">LOK Cost Locked</md-option>
                  <md-option value= "" >Both BLC and LOK</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div v-if="getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/apar/settelmentlist']">
              <callingApiCenter path=" /api/w/apar/settelmentlist" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">supervised_user_circle</span>Search</md-button>
                <md-button class="md-raised custButton" @click="doClear"><span class="icons-center material-icons">cached</span>Reset</md-button>
                <span class="lable-center">Next Payroll#: </span>
                <span class="data-center">{{getselectedSettleDate}}###</span>
                <span class="lable-center">Gross Settlement Amount: </span>
                <span class="data-center">{{getselectedTol}}</span>
                <span class="lable-center">   </span>
                <md-button class="md-raised custButton md-primary" :disabled="!canEdit || this.getPermission.stcreadonly.view" @click="dosettle" ><span class="icons-center material-icons">how_to_reg</span>Settle</md-button>

              <!-- <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button> -->
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                        <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                        <md-tooltip md-direction="top">All</md-tooltip>
                      </th>
                      <th class="header-cell center w6" v-on:click="sortFunction('payrollNum')">Payroll#</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('billingNum')">Doc#</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('billingStatus')">BillSts</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('deliveryType')">Type</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('billingDate')">Doc Date</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('settleDate')">Settle Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('partner')">Partner</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Ctnr#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">chassisNo</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('containerPickUpLocation')">CTNR Pickup</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('containerDropOffLocation')">CTNR Dropoff</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('tol')">Tol</th>
                      
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('pickupLocationCode')">pickupLocationCode</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('pickUpLocationName')">Pickup</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('deliverLocationCode')">deliverLocationCode</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('deliverLocationName')">Dropoff</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">Created</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">Created Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">Update</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">Update Date</th> -->
                    </tr>  
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <!-- <md-checkbox v-model="item.selected"> -->
                        <md-checkbox v-if="item.payrollNum == 'TBA'" v-model="item.selected">
                          <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                        </md-checkbox>
                      </td>
                      <td class="body-cell excelBox w6">{{item.payrollNum}}</td> 
                      <td class="body-cell excelBox w4">{{item.billingNum}}</td> 
                      <td class="body-cell excelBox w3">{{item.billingStatus}}</td> 
                      <td class="body-cell excelBox w2">{{item.deliveryType}}</td>
                      <td class="body-cell excelBox w4">{{item.billingDate | date}}</td>
                      <td class="body-cell excelBox w4">{{item.settleDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.partner}}</td>
                      <td class="body-cell excelBox w6">{{item.refDoc}}</td>
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                      <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                      <td class="body-cell excelBox w5">{{item.containerPickUpLocation}}</td>
                      <td class="body-cell excelBox w5">{{item.containerDropOffLocation}}</td>
                      <td class="body-cell excelBox w5">{{item.rdesc}}</td> 
                      <td class="body-cell excelBox w3">{{item.tol}}</td>
                      <!-- <td class="body-cell excelBox w5">{{item.pickupLocationCode}}</td>
                      <td class="body-cell excelBox w5">{{item.pickUpLocationName}}</td>
                      <td class="body-cell excelBox w5">{{item.deliverLocationCode}}</td>
                      <td class="body-cell excelBox w5">{{item.deliverLocationName}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td> -->

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

.icons-center {
      vertical-align: bottom;
      margin-right: 10px;
      color: rgb(165, 236, 227);
      font-size: 25px;
  }

.lable-center {
    vertical-align: bottom;
    margin-left: 20px;
    font-size: 20px;
    color: #010855;
}

.data-center {
    vertical-align: bottom;
    font-size: 20px;
    color: #0b21e9;
}

  .inputBox {
      border: 1px solid #cacbcc;
      border-radius: 5px;
      color: #29303b;
      font-size: 18px;
      height: auto;
      line-height: 1.5em;
      padding: 5px 5px 5px 5px;
      margin-top: 5px;
  }

  .selected {
      background: rgb(238, 165, 238);
  }

  .center {
      text-align: center;
  }

  .custButton {
      margin: 10px;
      width: 120px;
      height: 40px;
      line-height:40px;
      font-size: 0.8rem;
  }

  .custSearchBar{
      margin: 10px;
      width: 200px;
      height: 40px;
      line-height:40px;
      font-size: 0.9rem;
      color: blue;
  }

  .custButtonRight {
      margin: 10px;
      width: 100px;
      height: 40px;
      float : right;
      color: green;
  }
</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import SettlementForm from '../components/SettlementForm.vue';
  import moment from 'moment';

  const getInitSearch = () => ({
    salesOffice: "LGB",
    billingStatus: null,
    docType: "STAGE",
    payrollNum: "TBA",
    driverCompany: null,
    settleDate: {
      startDate: null,
      endDate: null
    },
    selected: false,
    // lockUnlock: "BLC",

  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      active: true,
      items: [],
      sortStatus: true,
      filter:"",
      selectAll: false,
      // props: {
      //   mode: String,
      // },
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
      SettlementForm,
    },

    watch: {
      getpayrollSettle(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
        'getPermission',
        'getUserProfile',
        'getRole',
        'getpayrollSettle',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.payrollNum).includes(term) ||
                  this.includeNull(row.billingNumRateType).includes(term) ||
                  this.includeNull(row.partner).includes(term) ||
                  this.includeNull(row.deliveryType).includes(term) ||
                  this.includeNull(row.refDoc).includes(term) ||
                  this.includeNull(row.containerNo).includes(term) ||
                  this.includeNull(row.chassisNo).includes(term);
        })
      },

      canEdit() {
              return this.getSelectedItems.length != 0 ;
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
      
      getselectedTol() {
        return this.getSelectedItems.reduce((acc, item) => acc + parseInt(item.tol), 0);  
      },

      getselectedSettleDate() {
        return moment(this.searchRequest.settleDate.endDate).format('YYYYMMDD');
      },

    },


    async mounted() {
      // const cachedSearchRequest = this.$store.state.payrollSettle.searchRequest;
      const today= moment().subtract(1,'weeks').toDate();
      this.searchRequest.settleDate.startDate = moment(today).startOf('week').toDate();
      this.searchRequest.settleDate.endDate = moment(today).endOf('week').toDate();
      this.searchRequest.salesOffice = 'LGB' ; 
      // this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getpayrollsettle);
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },
      mouseLeave: function() {
        this.active = !this.active;
      },

      handleDriverCompanyChanged(id){
              this.searchRequest.driverCompany = id;
          },

      sortFunction(sortFiled){
        const sorted = _(this.items).sortBy(sortFiled);
        console.log(this.sortStatus)
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus)
        {
            this.items = sorted;
        }
        else
        {
            this.items = sorted.reverse();
        }
      },

      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
      },
      
      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource)) ;
        items.forEach((it) => {
          it.selected ;
        });
        this.items = items;         
      },

      async dosettle() {

        this.$refs.SettlementForm.openDialog(this.searchRequest.driverCompany, this.getselectedSettleDate, this.getselectedTol,this.getSelectedItems);
        
      },

      async updatePayrollNum() {

        this.items.forEach( (it) => {
               if (it.payrollNum != "TBA" ) {
                  it.selected = false;
               }   
            });
      },

      doSearch() {
        this.active = true;
        this.selectAll = false; 
        if (this.searchRequest.settleDate.startDate == null)
        {
          window.confirm('Settle From is required!')
          return;
        }
        if (this.searchRequest.settleDate.endDate == null)
        {
          window.confirm('Settle To is required!')
          return;
        }

        if (this.searchRequest.driverCompany == null)
        {
          window.confirm('Driver Company is required!')
          return;
        }

        this.searchRequest.mode = "settle";
        this.$store.dispatch('payrollSettle', this.searchRequest);
       },

      doClear(){
        // this.filter = "";
        this.searchRequest = getInitSearch();
        
        const today= moment().subtract(1,'weeks').toDate();
        this.searchRequest.settleDate.startDate = moment(today).startOf('week').toDate();;
        this.searchRequest.settleDate.endDate = moment(today).endOf('week').toDate();
            
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      includeNull(field){
            return field==null ? '' : field;
        },
     },
    }
</script>

